import * as React from 'react'
import { NameValue } from './typings'
import { NameValueListItem } from './NameValueListItem/NameValueListItem'
import { Divider } from './NameValueListItem/styled'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

type Props = {
  divider?: boolean
  excludeNames?: string[]
  list: NameValue[]
  marginBottom?: number
}

function filterNameValueList(
  input: NameValue[],
  namesToFilter: string[],
): NameValue[] {
  const output: NameValue[] = []
  input.forEach((x) => {
    if (
      namesToFilter.findIndex(
        (y) => y.toLowerCase() === x.name.toLowerCase(),
      ) === -1
    ) {
      output.push(x)
    }
  })
  return output
}

export function NameValueList(props: Props) {
  const {
    divider = true,
    excludeNames = [],
    list,
    marginBottom = divider ? 0 : 12,
  } = props

  const filteredList = filterNameValueList(list, excludeNames)
  return (
    <Stack>
      {filteredList.map((item, index) => (
        <Box key={index} sx={{ marginBottom: `${marginBottom}px` }}>
          <NameValueListItem label={item.name} value={item.value} />
          {divider && <Divider />}
        </Box>
      ))}
    </Stack>
  )
}
